import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import RoomsSection from './components/RoomsSection';
import GardenSection from './components/GardenSection';
import AmenitiesSection from './components/AmenitiesSection';
import AwardsSection from './components/AwardsSection';
import AvailableOnRequest from './components/AvailableOnRequest';
import HonestCircumstancesSection from './components/HonestCircumstancesSection';
import BookingsSection from './components/BookingsSection';
import BeyondBnBSection from './components/BeyondBnBSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="bg-cream min-w-[1024px]">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <RoomsSection />
      <GardenSection />
      <AmenitiesSection />
      <AwardsSection />
      <AvailableOnRequest />
      <HonestCircumstancesSection />
      <BeyondBnBSection />
      <BookingsSection />
      <Footer />
    </main>
  );
}
